export const LOADING_QUIPS = [
  'Accio Icons!',
  'By the power of fa-skull…',
  'Hold onto your fa-butts.',
  'Our spirit animal is fa-rabbit-running.',
  'Patience you must have my young fa-dawan',
  "Shh. Be vewy vewy quiet. We're loading icons.",
  'Stay on target. Stay on target.',
  'This should take a little less than your average Kessel Run.',
  'When this thing gets up to 88 mph…',
  'Unloading fresh icons off of the fa-truck…',
  'Uploading fa-space-station-moon plans…',
  'Taking icons out of the fa-oven. Can you smell them?',
  'Finding the key to the icon fa-treasure-chest…'
]
